/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FileWorkflowControllerCreateRequestStepsInner { 
    actionType: FileWorkflowControllerCreateRequestStepsInner.ActionTypeEnum;
    assignedUserId: number;
}
export namespace FileWorkflowControllerCreateRequestStepsInner {
    export type ActionTypeEnum = 'review' | 'approve' | 'authorize' | 'acknowledge' | 'seen';
    export const ActionTypeEnum = {
        Review: 'review' as ActionTypeEnum,
        Approve: 'approve' as ActionTypeEnum,
        Authorize: 'authorize' as ActionTypeEnum,
        Acknowledge: 'acknowledge' as ActionTypeEnum,
        Seen: 'seen' as ActionTypeEnum
    };
}


